import { z } from 'zod/v4';

export const UpdateUserCompanyParamsSchema = z.object({
  id: z.string().min(1, 'User company ID is required'),
});

export type UpdateUserCompanyParams = z.infer<
  typeof UpdateUserCompanyParamsSchema
>;

/**
 * `role` is deliberately not a field here: no current UI in either frontend
 * ever sends it, and the real, IAM-native way to change someone's role is
 * `POST/DELETE /roles/:key/members` (`backend/src/api/routes/permissions/roles.routes.ts`),
 * which operates on an exact role key with no legacy-bucket collapsing. This
 * admin endpoint is for `isPrimary` only.
 */
export const UpdateUserCompanyBodySchema = z.object({
  isPrimary: z.boolean().optional(),
});

export type UpdateUserCompanyBody = z.infer<typeof UpdateUserCompanyBodySchema>;

export const UpdateUserCompanyResponseSchema = z.object({
  id: z.string(),
  userId: z.string(),
  companyId: z.string(),
  isPrimary: z.boolean(),
});

export type UpdateUserCompanyResponse = z.infer<
  typeof UpdateUserCompanyResponseSchema
>;
